import { EmployerHeader, EmployerFooter } from '@seek/adv-header-footer';
import type { Locale } from '@seek/melways-sites';
import { Box, Page } from 'braid-design-system';
import type { ReactNode } from 'react';

import { trackHeaderFooterInteractions } from 'src/modules/AnalyticsTracker';
import { useAccountContext } from 'src/modules/ApiClient';
import type { EmployerSiteName } from 'src/types';
import { isStaging } from 'src/utils/config';

interface Props {
  children: ReactNode;
  site: EmployerSiteName;
  locale: Locale;
}

export const MainLayout = ({ children, site, locale }: Props) => {
  const { data: accountContext } = useAccountContext();

  return (
    <Page
      footerPosition="belowFold"
      footer={
        <EmployerFooter
          site={site}
          locale={locale}
          isStaging={isStaging()}
          onTrackedItemInteraction={trackHeaderFooterInteractions}
          advertiser={accountContext?.advertiser}
          identityContext={accountContext?.identityContext}
        />
      }
    >
      <EmployerHeader
        activeTabId="home"
        site={site}
        locale={locale}
        isStaging={isStaging()}
        onTrackedItemInteraction={trackHeaderFooterInteractions}
        advertiser={accountContext?.advertiser}
        identityContext={accountContext?.identityContext}
        user={accountContext?.user}
        divider
      />
      <Box component="main">{children}</Box>
    </Page>
  );
};
